import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface PeopleCountChartProps {
  data: { time: string; count: number }[];
}

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    title: { display: true, text: "Pessoas ao longo do tempo" },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 1,
        precision: 0,
        callback: function (value: number) {
          return Number.isInteger(value) ? value : null;
        },
      },
    },
  },
};

const PeopleCountChart: React.FC<PeopleCountChartProps> = ({ data }) => {
  return (
    <div style={{ width: "100%", margin: "0 auto", maxHeight: 400, height: 400 }}>
      <Line
        data={{
          labels: data.map((item) => item.time),
          datasets: [
            {
              data: data.map((item) => item.count),
              fill: false,
              borderColor: "rgb(75, 192, 192)",
              tension: 0.1,
            },
          ],
        }}
        options={chartOptions}
      />
    </div>
  );
};

export default PeopleCountChart;